export default {
    sdkVersion: '0.12.2',
};
